import React, { Fragment, useState } from 'react';
import { Link } from '@mui/material';
import { useLocalization } from '@/hooks/useLocalization';
import ClientDetailsFlyout from '@/components/flyouts/ClientDetailsFlyout/ClientDetailsFlyout';
import { investorName, type AccountInvestor } from '../utils/accountInvestors';

interface AccountHeldByProps {
  investors: AccountInvestor[];
}

const separatorBefore = (index: number, count: number, and: string) => {
  if (index === 0) return '';
  if (index < count - 1) return ', ';
  return count > 2 ? `, ${and} ` : ` ${and} `;
};

const AccountHeldBy: React.FC<AccountHeldByProps> = ({ investors }) => {
  const { t } = useLocalization();
  const [selectedInvestorId, setSelectedInvestorId] = useState<number | null>(
    null,
  );
  const and = t('common.and', 'and');

  return (
    <>
      {investors.map((investor, index) => (
        <Fragment key={investor.InvestorId}>
          {separatorBefore(index, investors.length, and)}
          <Link
            component='button'
            type='button'
            underline='hover'
            sx={{ font: 'inherit', verticalAlign: 'baseline' }}
            onClick={() => {
              setSelectedInvestorId(investor.InvestorId);
            }}
          >
            {investorName(investor)}
          </Link>
        </Fragment>
      ))}
      {selectedInvestorId !== null && (
        <ClientDetailsFlyout
          open
          toggleDrawer={(value) => {
            if (!value) setSelectedInvestorId(null);
          }}
          client={{ InvestorId: selectedInvestorId }}
        />
      )}
    </>
  );
};

export default AccountHeldBy;
